import _ from "lodash";
import { useState, useEffect } from "react";

function getSize() {
  const sizeIds = {
    xlPlus: window.innerWidth >= 1280,
    lgPlus: window.innerWidth >= 1024,
    mdPlus: window.innerWidth >= 768,
    smPlus: window.innerWidth >= 640,
    xs: window.innerWidth < 640,
  };

  return {
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth < 768,
    sizeId: Object.keys(sizeIds).find(id => sizeIds[id]),
  };
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({});

  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }

    setWindowSize(getSize());

    const debounced = _.debounce(handleResize, 200);

    window.addEventListener("resize", debounced);
    return () => window.removeEventListener("resize", debounced);
  }, []);

  return windowSize;
}

export default useWindowSize;
